import { render, staticRenderFns } from "./full-agreement.vue?vue&type=template&id=f208dfea&scoped=true"
import script from "./full-agreement.vue?vue&type=script&lang=js"
export * from "./full-agreement.vue?vue&type=script&lang=js"
import style0 from "./full-agreement.vue?vue&type=style&index=0&id=f208dfea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f208dfea",
  null
  
)

export default component.exports